import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { DEV_SERVERS } from 'src/constants';
import type { RootState } from '../storeConfig/store';

type DevConfigState = {
  value: string;
  label: string;
};

const initialState: DevConfigState = DEV_SERVERS[0];

export const devConfigSlice = createSlice({
  name: 'devConfig',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<string>) => {
      const value = action.payload;
      const server = DEV_SERVERS.find(e => e.value === value) ?? {
        label: 'custom',
        value,
      };

      return { ...state, ...server };
    },
    onNextServer: state => {
      const currentIndex =
        DEV_SERVERS.findIndex(e => e.value === state.value) ?? -1;
      const nextIndex = currentIndex + 1;
      const nextValue = DEV_SERVERS[nextIndex] ?? DEV_SERVERS[0];
      return nextValue;
    },
  },
});

export const { set } = devConfigSlice.actions;

export const selectDevServer = (state: RootState) => state.devConfig;

export default devConfigSlice.reducer;
